import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;
//查询场馆列表不分页
export const getStadiumData = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueListData`, { params: params });
};
//查询场馆列表
export const getStadiumList = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueList`, { params: params });
};
//通过id查询场馆详情
export const getStadiumDetail = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueDetail`, {
    params: params,
  });
};
//新增场馆
export const addStadium = (data) => {
  return axios.post(`${base}/api/Venue/PostAddVenue`, data);
};
//更新场馆
export const updateStadium = (data) => {
  return axios.post(`${base}/api/Venue/PostUpdateVenue`, data);
};
//删除场馆
export const deleteStadium = (params) => {
  return axios.delete(`${base}/api/Venue/DeleteVenue`, { params: params });
};
//新增场地
export const addSite = (data) => {
  return axios.post(`${base}/api/Venue/PostAddVenueCourtSite`, data);
};

//获取场地列表
export const getSiteList = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueCourtSiteList`, {
    params: params,
  });
};
//获取场地列表不分页
export const getSiteData = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueCourtSiteListData`, {
    params: params,
  });
};

//根据id获取场地详情
export const getSiteDetail = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueCourtSiteDetail`, {
    params: params,
  });
};
//删除场地
export const deleteSite = (params) => {
  return axios.delete(`${base}/api/Venue/DeleteVenueCourtSite`, {
    params: params,
  });
};
//编辑场地
export const editSite = (data) => {
  return axios.post(`${base}/api/Venue/PostUpdateVenueCourtSite`, data);
};

//获取订场列表
export const getCourtList = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueCourtList`, {
    params: params,
  });
};
//获取订场列表不分页
export const getCourtData = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueCourtListData`, {
    params: params,
  });
};
//新增订场
export const addCourt = (data) => {
  return axios.post(`${base}/api/Venue/PostAddVenueCourt`, data);
};
//修改订场
export const editCourt = (data) => {
  return axios.post(`${base}/api/Venue/PostUpdateVenueCourt`, data);
};
//订场详情
export const courtDetail = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueCourtDetail`, {
    params: params,
  });
};

//删除订场
export const deleteCourt = (params) => {
  return axios.delete(`${base}/api/Venue/DeleteVenueCourt`, { params: params });
};

//场地评价部分
//获取场地评价列表
export const commentList = (params) => {
  return axios.get(`${base}/api/VenueComment/GetVenueCommentList`, {
    params: params,
  });
};
//场地评价详情
export const commentDetail = (params) => {
  return axios.get(`${base}/api/VenueComment/GetVenueCommentDetail`, {
    params: params,
  });
};

//删除评价
export const deleteComment = (params) => {
  return axios.delete(`${base}/api/VenueComment/DeleteVenueComment`, {
    params: params,
  });
};

//获取所有场馆
export const GetVenueDataList = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueDataList`, { params: params });
};

export const GetVenueCourtListData = (params) => {
  return axios.get(`${base}/api/Venue/GetVenueCourtListData`, {
    params: params,
  });
};
